export default "__VITE_ASSET__Bcd7Fwf5__"